import { render, staticRenderFns } from "./GroupChecks.vue?vue&type=template&id=21ea786b"
import script from "./GroupChecks.vue?vue&type=script&lang=js"
export * from "./GroupChecks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports